// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2C04Q","sendOtp":"AuthorizeToLogin_sendOtp__2alg9"};